import { render, staticRenderFns } from "./RelatorioAusenciaCheckinListRoute.vue?vue&type=template&id=5a912d32"
import script from "./RelatorioAusenciaCheckinListRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioAusenciaCheckinListRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports